// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"20c1fcd5","678":"6b34d59c","963":"77e4c15d"}[chunkId] + ".chunk.js";
};